
export default () => (
  <>
    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      Foundation's Purpose and Vision
    </h2>
    <div className="cs-bid_info" >
      <div className="min-titlef">Responding to Climate Change: No Longer an Option, but a Necessity</div>
      <div style={{ textAlign: "start" }}>Climate change is one of the most critical challenges facing humanity. It is no longer enough to observe that the climate is changing—we must recognize that climate change is actively causing disasters and take action. The global commitment to net zero can only delay the impending climate crisis; it is not a fundamental solution. Instead of merely aiming for net zero, we must go beyond and achieve carbon negativity, reducing atmospheric greenhouse gas concentrations to pre-industrial levels. Now is the time for fundamental change to ensure a sustainable future, rather than mere environmental protection.<br />
        The Climate Foundation was established in response to this urgent need, introducing a new paradigm in carbon reduction and carbon credit trading. "Lowering atmospheric greenhouse gas levels" is our clear mission. The current voluntary carbon credit market faces several critical issues: ambiguous MRV (Measurement, Reporting, and Verification) processes, non-transparent certification procedures, unreliable reduction effects, and overly complex transaction structures.<br />
        The Climate Foundation was founded to address these issues by establishing a trustworthy, scientifically validated voluntary carbon credit certification and trading system. Our goal is to ensure reliability through rigorous scientific certification procedures, implement a transparent and user-friendly trading environment, and create a sustainable carbon reduction ecosystem. This will enable individuals, organizations, corporations, and even entire nations to actively contribute to carbon negativity.</div>
    </div>


    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      The Role of the Climate Foundation in a Sustainable Future
    </h2>
    <div className="cs-bid_info">
      <div className="text-center">
        We are not just another carbon credit trading platform.
        <br />
        We aim to set a new standard for tackling climate change and build a fair, sustainable carbon credit market
      </div>
      <div className="agreement-panel">
        <ul>
          <li>A Reliable Carbon Credit Certification System : Our system ensures that companies and individuals can confidently participate in carbon reduction initiatives.</li>
          <li>Blockchain-Enabled Transparency : By leveraging blockchain technology, we create a transparent trading environment that enhances trust throughout the carbon credit lifecycle.</li>
          <li>Accessibility for Everyone : We make it easy for anyone to contribute to carbon neutrality, democratizing climate action</li>
        </ul>
      </div>
      <div className="text-center">
        The Climate Foundation will establish itself as the most credible carbon credit certification body, playing a vital role in securing a sustainable future.
        <br />
        Carbon neutrality is not just an ambitious goal—it is now an achievable, practical solution.
        <br />
        We invite you to join us in building a better future.
        <br />
        Together, we are paving a new path to carbon neutrality and a more sustainable world.
      </div>
    </div>
    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      The Climate Foundation's New Carbon Credit Market
    </h2>

    <div className="cs-bid_info">
      <div className="min-titlef">01 Stringent Certification for Maximum Reliability</div>
      <div className="text-center">
        The current carbon credit market suffers from a lack of transparency, making it difficult to verify the legitimacy of projects. Some projects issue credits without actual reduction effects or inflate reported reduction amounts, distorting the market.
        <br />
        The Climate Foundation ensures the reliability of carbon reduction projects through a rigorous certification process.
      </div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li>
            <label>Multi-Level Evaluation Process :</label>
            Once a project is registered, we analyze its methodology and estimated reduction impact before verifying its actual results.
          </li>
          <li>
            <label>Strict Certification Criteria :</label>
            Our system is based on eight key evaluation criteria, applying stricter internal standards.
          </li>
          <li>
            <label>Data-Driven Verification : </label>
            We review historical reduction data and involve independent third-party verification agencies to ensure accuracy.
          </li>
          <li>
            <label>Continuous Monitoring : </label>
            Beyond initial certification, we regularly track reduction performance to maintain trust in our MRV system.
          </li>
        </ul>
      </div>
      <div className="text-center">
        Carbon credits that pass our certification process are proven to have verifiable reduction effects, allowing companies and individuals to confidently participate in carbon reduction activities.
      </div>
      <div className="min-titlef">02 Blockchain-Based Transparent Transactions</div>
      <div className="text-center">
        The carbon credit market has long been plagued by double counting, opaque transaction records, and a lack of trust. The Climate Foundation leverages blockchain technology to ensure the traceability and credibility of carbon credits
      </div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li>
            <label>Real-Time Transaction Visibility : </label>
            All carbon credit issuance, sales, and usage records are stored on the blockchain and can be publicly verified.
          </li>
          <li>
            <label>Double Counting Prevention :</label>
            Smart contracts ensure that once a carbon credit is used, it cannot be resold or counted again.
          </li>
          <li>
            <label>Transparent Verification System :</label>
            The authenticity of carbon reduction effects and transaction records is secured against tampering, creating a trusted market environment for both businesses and individuals.
          </li>
        </ul>
      </div>
      <div className="text-center">
        By implementing a blockchain-based approach, we eliminate distrust and provide a reliable trading environment for everyone.
      </div>
      <div className="min-titlef">03 A Platform for Universal Participation</div>
      <div className="text-center">
        The current carbon credit market is not easily accessible to the general public, and even corporations face challenges due to complicated transaction processes.
        <br />
        The Climate Foundation builds a user-friendly platform that allows both companies and individuals to engage in carbon reduction activities effortlessly.
      </div>

      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li>
            <label>Intuitive User Interface  : </label>
            Simplifying the process so users can buy or trade carbon credits with just a few clicks.
          </li>
          <li>
            <label>Corporate Solutions  :</label>
            Helping businesses set and achieve their own carbon neutrality goals with customized strategies.
          </li>
          <li>
            <label>Individual Engagement  :</label>
            Enabling ordinary consumers to purchase carbon credits and offset their carbon footprint easily.
          </li>
        </ul>
      </div>
    </div>


    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      Chairman’s Message
    </h2>
    <div className="cs-bid_info">
      <div className="min-titlef">
        "Setting a New Standard for Carbon Neutrality"
      </div>
      <div className="text-center">
        Dear Esteemed Colleagues,<br />
        Climate change is no longer a challenge for the future—it is a pressing reality we must address today. While various efforts are being made to reduce carbon emissions and achieve carbon neutrality, the current carbon credit market faces significant limitations due to non-transparent certification processes, lack of reliability, and issues such as double counting.
        The Climate Foundation was established to solve these problems and create a transparent and trustworthy certification and trading system for carbon credits. By implementing rigorous certification procedures, blockchain-based transparent data management, and an accessible trading environment, we aim to facilitate more effective carbon reduction.
      </div>
      <div className="min-titlef">The Role and Objectives of the Climate Foundation</div>
      <div className="agreement-panel">
        <ul>
          <li>
            <b>Reliable Carbon Credit Certification</b><br />
            ️Verification based on scientific data and quantitative analysis<br />
            Strict certification processes in compliance with global standards
          </li>
          <li>
            <b>Transparent Carbon Credit Trading Environment</b><br />
            Blockchain-based data recording to prevent transaction manipulation and double counting<br />
            Complete transparency, allowing anyone to verify transaction records
          </li>
          <li>
            <b>A Carbon Neutrality System Accessible to Everyone</b><br />
            A streamlined platform enabling individuals and businesses to easily purchase and utilize carbon credits<br />
            Support for not only large corporations but also SMEs and individuals to contribute to carbon neutrality
          </li>
        </ul>
      </div>
      <div className="min-titlef">Our Commitment to the Future</div>
      <div className="agreement-panel">
        <div className="min-titlef">"We will build a trustworthy carbon credit market to create a sustainable future."</div>
        <div className="text-center">
          A sustainable future is not achieved through declarations alone—it requires a robust system that generates tangible carbon reduction effects and ensures fair evaluation.
          The Climate Foundation is committed to establishing a new standard for carbon neutrality and ensuring that carbon reduction efforts translate into real value.
          Carbon neutrality is no longer an option—it is a necessity.<br />
          Join us at the Climate Foundation as we pave the way for a more sustainable future.
          Thank you.
        </div>
        <div className="min-titlef">
          Song BongKwan<br />
          Chairman, Climate Foundation
        </div>
      </div>
    </div>

    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      Director’s Message
    </h2>
    <div className="cs-bid_info">
      <div className="min-titlef">Hello, I am Kang Shin-Geol,</div>
      <div className="text-center">
        Director of the Climate Foundation.<br />
        We are living in a time where the global climate crisis is intensifying. Carbon neutrality is no longer an option but a necessity, a crucial goal that individuals, businesses, and society as a whole must work toward for a sustainable future. The Climate Foundation was established to lead this transformation by promoting practical and effective carbon reduction initiatives and fostering a sustainable environment.
      </div>
      <div className="text-center">
        With my background in business expertise, I am committed to ensuring that the Climate Foundation operates carbon reduction projects in a systematic, transparent, and reliable manner. My role is not only to engage in discussions about climate issues but to develop real solutions and create a structure that allows businesses and individuals to participate easily.
      </div>
      <div className="text-center">
        The Climate Foundation is building a trusted and effective platform for carbon credit trading and reduction projects. Our goal is to create a market structure based on certified carbon credits and establish an efficient distribution environment where businesses and individuals can seamlessly contribute to carbon neutrality.
      </div>
      <div className="text-center">
        Our platform is not just a transaction system—it is a key tool for ensuring effective carbon reduction, reliable investment, and corporate participation. We focus on enhancing the credibility of projects, ensuring clear issuance and verification of carbon credits, and building a trustworthy and efficient market.
      </div>
      <div className="text-center">
        As a director, I am dedicated to ensuring that the Foundation is operated with professionalism and responsibility. My focus is on strategic planning and execution, ensuring that our efforts go beyond mere declarations and result in tangible carbon reduction outcomes. We will continue to earn market trust and manage reduction projects effectively to achieve meaningful environmental impact.
      </div>
      <div className="text-center">
        Our mission is not just to create a carbon credit trading market but to encourage more people to participate in carbon reduction actively and help businesses integrate carbon neutrality into their operations. To achieve this, the Climate Foundation will operate with greater transparency, systematic processes, and long-term sustainability.
      </div>
      <div className="text-center">
        I invite you to continue supporting and engaging with the Climate Foundation. Together, we can achieve carbon neutrality. Every effort we make contributes to a better future.
      </div>
      <div className="text-center">Thank you.</div>
      <div>
        <b>
          Kang Shin-Geol<br />Director, Climate Foundation
        </b>
      </div>
    </div>

  </>
);
